import React from 'react'
import { useTranslation } from 'react-i18next'
import { Popover, Typography } from 'antd'
import type { ResourceSelector } from '@/models/ecs'
import ResourceSelectorShow from '@/app/components/mlops/ResourceSelector'

const { Text } = Typography

type ResourceSelectorDescProps = {
  resource_selector: ResourceSelector
  type?: 'ecs' | 'train' | 'deploy'
  train_type?: 'pytorch' | 'tensorflow'
}

const ResourceSelectorDesc: React.FC<ResourceSelectorDescProps> = ({
  resource_selector,
  type = 'ecs',
  train_type,
}) => {
  const { t } = useTranslation()
  if (!resource_selector) {
    return <Text>{t('train.taskList.unknown')}</Text>
  }
  return (
    <>
      <Popover
        content={
          <ResourceSelectorShow
            type={type}
            train_type={train_type}
            disabled={true}
            value={resource_selector}
          />
        }>
        {resource_selector ? (
          resource_selector.resource_spec_id ? (
            resource_selector.resource_spec?.name
          ) : (
            <Typography.Link>{t('train.taskList.view')}</Typography.Link>
          )
        ) : (
          <Text>--</Text>
        )}
      </Popover>
    </>
  )
}

export default ResourceSelectorDesc
